import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "@/router/config";
import { useScrollToTop } from "@/hooks/useScrollToTop";


let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

/**
 * AppRoutes Component
 * Handles functional side effects for navigation and scroll management.
 */
export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();

  // Unified Reactive Scroll Handling
  useScrollToTop();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  }, [navigate]);

  return element;
}